import script from "./Interim3.vue?vue&type=script&setup=true&lang=js"
export * from "./Interim3.vue?vue&type=script&setup=true&lang=js"

import "./Interim3.vue?vue&type=style&index=0&id=10ce5127&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ce5127"]])

export default __exports__